import Vue from 'vue';
import VueRouter from 'vue-router';

import { getUserType, getToken } from '../core/js/data';
import { t } from '../core/i18n/index';
import { Message } from 'element-ui';

import routes from './routes';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
    routes
});

const guestRoutes = ['/login', '/404', '/test']; // 无需登录的页面

router.beforeEach((to, from, next) => {
    const userType = getUserType()

    if (to.meta && to.meta.key) {
        document.title = 'IOT | ' + t('title.' + to.meta.key)
    } else {
        document.title = 'HORWIN IOT'
    }

    if (guestRoutes.includes(to.path)) {
        next();
    } else {
        const token = getToken();
        if (!token) {
            // 没登录
            Message.warning(t(/*请先登录*/'tip.please_login'));
            next('/login');
        } else {
            // 已登录
            const role = to.meta.role;
            // next();
            if (role) {
                // 如果进入的路由meta中有role规则
                if (role.includes(userType)) {
                    // 如果当前usertType在role arr中有
                    next();
                } else {
                    // 表前userType禁止访问
                    Message.warning(t(/*当前身份无法访问*/'tip.no_identity'));
                    next('/home');
                }
            } else {
                // 没有role规则直接放行
                next();
            }
        }
    }
});

export default router;
